<footer class="w-full bg-white border-t border-gray-200 py-4">
  <div class="max-w-7xl mx-auto px-6">
    <div class="flex items-center justify-center gap-6 mb-3">
      <a
        href="https://grupobimbo.csod.com/SAMLdefault.aspx?ouid=2&returnurl=DeepLink/ProcessRedirect.aspx?module=42"
        target="_blank"
        rel="noopener noreferrer"
        class="text-sm font-medium text-blue-700 hover:text-blue-800 hover:underline">
        GB University
      </a>
    </div>

    <p class="text-xs text-gray-500 text-center max-w-4xl mx-auto leading-relaxed">
      All rights reserved, GRUPO BIMBO, S.A.B. DE C.V. (2026). Any publication, retransmission,
      editing and any other use of the contents without prior authorization is forbidden.
    </p>
  </div>
</footer>
